export class RecordsDetained {
    get id() {
        return this.recordsDetainedState.id;
    }
    get inRegister() {
        return this.recordsDetainedState.inRegister;
    }
    get inDate() {
        return this.recordsDetainedState.inDate;
    }
    get origin() {
        return this.recordsDetainedState.origin;
    }
    get agentReceptorId() {
        return this.recordsDetainedState.agentReceptorId;
    }
    get outRegister() {
        return this.recordsDetainedState.outRegister;
    }
    get outDate() {
        return this.recordsDetainedState.outDate;
    }
    get destination() {
        return this.recordsDetainedState.destination;
    }
    get agentDeliveryId() {
        return this.recordsDetainedState.agentDeliveryId;
    }
    get diligenceId() {
        return this.recordsDetainedState.diligenceId;
    }
    get crime() {
        return this.recordsDetainedState.crime;
    }
    get judicialProcedures() {
        return this.recordsDetainedState.judicialProcedures;
    }
    get thirdId() {
        return this.recordsDetainedState.thirdId;
    }
    get observations() {
        return this.recordsDetainedState.observations;
    }
    get userId() {
        return this.recordsDetainedState.userId;
    }
    set id(id) {
        this.recordsDetainedState.id = id;
    }
    set inRegister(inRegister) {
        this.recordsDetainedState.inRegister = inRegister;
    }
    set inDate(inDate) {
        this.recordsDetainedState.inDate = inDate;
    }
    set origin(origin) {
        this.recordsDetainedState.origin = origin;
    }
    set agentReceptorId(agentReceptorId) {
        this.recordsDetainedState.agentReceptorId = agentReceptorId;
    }
    set outRegister(outRegister) {
        this.recordsDetainedState.outRegister = outRegister;
    }
    set outDate(outDate) {
        this.recordsDetainedState.outDate = outDate;
    }
    set destination(destination) {
        this.recordsDetainedState.destination = destination;
    }
    set agentDeliveryId(agentDeliveryId) {
        this.recordsDetainedState.agentDeliveryId = agentDeliveryId;
    }
    set diligenceId(diligenceId) {
        this.recordsDetainedState.diligenceId = diligenceId;
    }
    set crime(crime) {
        this.recordsDetainedState.crime = crime;
    }
    set judicialProcedures(judicialProcedures) {
        this.recordsDetainedState.judicialProcedures = judicialProcedures;
    }
    set thirdId(thirdId) {
        this.recordsDetainedState.thirdId = thirdId;
    }
    set observations(observations) {
        this.recordsDetainedState.observations = observations;
    }
    set userId(userId) {
        this.recordsDetainedState.userId = userId;
    }
    constructor(recordsDetainedState) {
        this.recordsDetainedState = recordsDetainedState;
    }
    getState() {
        return this.recordsDetainedState;
    }
}
